"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query read($subscriptionId: Int!, $day: Int, $week: Int){
  progressCollection (subscriptionId: $subscriptionId, day: $day, week: $week){
    id
    day
    date
    
    didLesson
    trained
    drankWater
    supplemented
    ateAsRecommended
    
    lessonOrdinalNumber
    lessonTitle
  }
}
`;
//# sourceMappingURL=getBehaviourOfWeek.js.map